import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  // Replace with your actual WhatsApp number
  const phoneNumber = '201553555330'; 
  const message = 'Hello, I have a question about VetCare Store.';

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={handleClick}>
      <ion-icon name="logo-whatsapp" class="whatsapp-icon"></ion-icon>
    </div>
  );
};

export default WhatsAppButton;
